export enum ShipmentStatus {
  STORED = 'STORED',
  CREATED = 'CREATED',
  CONFIRMED = 'CONFIRMED',
  PRE_TRANSPORT = 'PRE_TRANSPORT',
  IN_TRANSIT = 'IN_TRANSIT',
  PICKUP = 'PICKUP',
  DESTINATION_HANDLING = 'DESTINATION_HANDLING',
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  EXCEPTION = 'EXCEPTION',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  CANCELED = 'CANCELED'
}



// WEBPACK FOOTER //
// ./src/app/model/shipment-status.enum.ts